import { BaseBus } from "./BaseBus";
import { v_OrderDispatchBus } from "./v_OrderDispatchBus";

export class v_OrderBus extends BaseBus
{
    orderId: any;
    companyId: any;
    supplierId: any;
    supplierLocationId: any;
    customerId: any;
    locationId: any;
    buyerPersonId: any;
    blanketAmount: number;
    isOrderPlaced: boolean;
    isOrderBilled: boolean;
    isOrderComplete: boolean;
    dateEntered: Date;
    dateRequested: Date;
    dateExpected: Date;
    orderNumber: string;
    shippingMethodId: any;
    notes: string;
    termId: any;
    customerName: string;
    locationName: string;
    supplierName: string;
    supplierLocationName: string;
    buyerPersonLastName: string;
    total: number;
    mfgNbrs: string;
    supplierNbrs: string;
    ccAccountId: any;
    isLocked: boolean;
    approverUserId: any;
    approvedDate: Date;
    employeeOrderPersonId: any;
    returnTrackNbr: string;
    returnVendTrackNbr: string;
    returnUserId: any;
    returnDt: Date;
    returnUser: string;
    isENbr: string;
    refNbr: string;
    acctMgr: string;
    requestedById: any;
    requestedByName: string;
    orderStatusId: any;
    orderStatusName: string;
    projMgrPersonId: any;
    chgOrdBlanketAmount: number;
    isSub: boolean;
    co: string;
    orderDispatchs: v_OrderDispatchBus[];
    amountBilled: number;
    amountPaid: number;
    dispatchId: any;
    divisionId: any;
    regionId: any;
    divisionName: string;
    regionName: string;
    dispatchNumber: string;
    dispatchStatusName: string;
    isConstruction: boolean;
    isJob: boolean;
    daysInDispatchStatus: number;
    daysInOrderStatus: number;
    techCreated: boolean;
    onCallRegionName: string;
}
